import { useContext } from 'react';

import TaskContext from '@atom/components/workOrderPreview/taskView/TaskContext';
import { setDurationDisplay } from '@atom/utilities/timeUtilities';

import classes from './taskView.module.css';

const TaskDuration = () => {
  const { task } = useContext(TaskContext);

  return (
    <div className={classes.timeRowItem}>
      <div className={classes.labelContainer}>
        <div className={classes.label}>Duration</div>
      </div>
      <div className={classes.dateDisplay}>
        {setDurationDisplay(task.duration)}
      </div>
    </div>
  );
};

export default TaskDuration;
